

  import { Component, Prop, Vue } from "vue-property-decorator";

  @Component
  export default class ResendInvitationConfirmation extends Vue {
    @Prop({type: String, required: true}) readonly givenName!: string;
    @Prop({type: String, required: true}) readonly familyName!: string;

    processing: boolean = false;
    invitationResent: boolean = false;

    confirm(): void {
      this.$confirm({
        title: "Resend Invitation",
        message: `You are going to resend invitation to ${this.givenName} ${this.familyName}`,
        button: {
          no: "Cancel",
          yes: "Resend",
        },
        callback: async (confirm: any) => {
          if (confirm) {
            this.$emit("confirmed");
          }
        },
      });
    }
  }
